import React, { ReactNode } from 'react';

interface StyleCharsRecursiveProps {
  children: ReactNode;
  styles: string;
}

const StyleCharsRecursive: React.FC<StyleCharsRecursiveProps> = ({
  children,
  styles,
}) => {
  return (
    <>
      {React.Children.map(children, (child, index) => {
        // If the child is a string, process it
        if (typeof child === 'string') {
          // Split the string by "+" or "%", keeping the delimiters
          const parts = child.split(/([+%])/g);
          return parts.map((part, partIndex) => {
            if (part === '+' || part === '%') {
              // Wrap the special character in a span using the 'styles' prop for Tailwind classes
              return (
                <span
                  key={`char-${index}-${partIndex}`}
                  className={styles} // Apply Tailwind classes from the 'styles' prop
                >
                  {part}
                </span>
              );
            }
            // Return other parts of the string as is
            return part;
          });
        }

        // If the child is a React element and has children, recursively process them
        if (
          React.isValidElement(child) && // TypeScript now knows 'child' is React.ReactElement
          child.props &&
          child.props.children
        ) {
          const { children: originalChildsChildren, ...otherProps } =
            child.props;

          return React.cloneElement(
            child,
            otherProps,
            <StyleCharsRecursive styles={styles}>
              {originalChildsChildren}
            </StyleCharsRecursive>,
          );
        }
        return child;
      })}
    </>
  );
};

export default StyleCharsRecursive;
